import { Controller } from "@hotwired/stimulus"

// Billing-contact reassignment: when "reassign every contact's records" is
// checked, the FROM select is irrelevant — disable and clear it so it isn't
// submitted (the job then reassigns all records to the target).
export default class extends Controller {
  static targets = ["from"]

  toggle(event) {
    const all = event.target.checked
    this.fromTarget.disabled = all
    if (all) this.fromTarget.value = ""
  }
}
